import React from "react";

const PageIntro = ({ title, description, active }) => {
  return (
    <>
      <div
        className="relative z-0  h-[75vh] md:max-h-[300px] rounded-xl my-[2px]  "
        // style={{
        //   backgroundImage: 'url("/assets/images/bg_hand.png")',
        //   backgroundSize: "cover",
        //   // backgroundPosition: "center",
        //   // backgroundRepeat: "no-repeat",
        // }}
      >
        {/* <div className="absolute "></div> */}
        {/* <img
          src="/assets/images/bg_hand.png"
          className="absolute w-[300px] opacity-30 z-10 mx-auto left-10  right-20 top-[10px]  lg:top-[40px]"
          alt=""
        /> */}
        <div
          className="z-20 w-full h-full flex flex-col justify-center items-center py-32 rounded-sm "
          style={{
            background: "rgb(221,239,230)",
            background:
              "linear-gradient(90deg, rgba(221,239,230,1) 0%, rgba(222,240,230,1) 31%, rgba(243,237,225,1) 100%)",
          }}
        >
          <div className="">
            <p className="text-[#030303] text-[35px] p-[20px] leading-10 md:leading-5 text-center font-semibold">
              {title}
            </p>
            <p className="text-center text-[14px] text-black px-12 ">
              {description}
            </p>
          </div>{" "}
        </div>
      </div>{" "}
      {!active && (
        <div className="z-0 w-full text-center  -mt-12   flex justify-center items-center">
          <div className=" w-full max-w-[600px] bg-white py-4 rounded-lg  shadow-md font-semibold ">
            <p className="text-[#030303] text-[35px] p-[8px] leading-5 text-center font-semibold flex justify-center items-center">
              <p className="text-[#009932]"> COMING_</p> SOON
            </p>
            <p className="font-normal text-[12px]">Stay Tuned</p>
          </div>
        </div>
      )}
    </>
  );
};

export default PageIntro;
